import chequesApi from "@/app/services/cheques";
import { datasParaIntervaloBR } from "@/app/utils/formatacoes";

export default {
    namespaced: true,
    state: {
        cheque: null,
        cheques: [],
        listagem: 'hoje',
        filtrando: false,
        filtro: {
          cliente_id: null,
          status: null,
          banco: null,
          vencimento: [],
          cadastro: [],
          search: ''
        },
        filtroChips: [],
        search: '',
        total_de_registros: 0,
        pagination: {}
    },

    mutations: {
      SET_CHEQUES(state, cheques) {
        state.cheques = cheques;
      },

      abrir(state, cheque) {
        state.cheque = cheque;
      },

      salvar(state, cheque) {
        state.cheques.push(cheque);
      },

      atualizar(state, cheque) {
        let index = state.cheques.findIndex(cheque_ => cheque_.id == cheque.id);
        if (index > -1) {
          console.log('Cheque:', cheque);
          state.cheques.splice(index, 1, cheque);
        }
      },

      atualizarStatusCheque(state, cheque) {
        let index = state.cheques.findIndex(cheque_ => cheque_.id == cheque.id);
        if (index > -1) {
          state.cheques.splice(index, 1, cheque);
        }
      },

      excluir(state, id) {
        let index = state.cheques.findIndex(cheque => cheque.id == id);
        if (index > -1) {
          state.cheques.splice(index, 1);
        }
      },

      UNSET_CHEQUE(state) {
        state.cheque = null;
      },

      SET_LISTAGEM(state, valor) {
        state.listagem = valor;
      },

      SET_FILTRO(state, filtro) {
        state.filtro = filtro;
      },

      PROCESSAR_FILTROCHIPS(state) {
        let items = [];
        
        if (state.filtro.cliente_id) {
          items.push({descricao: 'Cliente: ' + state.filtro.cliente_id, chave: 'cliente_id'});
        }

        if (state.filtro.status) {
          items.push({descricao: 'Status: ' + state.filtro.status, chave: 'status'});
        }

        if (state.filtro.banco) {
          items.push({descricao: 'Banco: ' + state.filtro.banco, chave: 'banco'});
        }

        if (state.filtro.vencimento.length > 0) {
          let intervalo = datasParaIntervaloBR(state.filtro.vencimento);
          items.push({descricao: 'Vencimento: ' + intervalo, chave: 'vencimento'});
        }

        if (state.filtro.cadastro.length > 0) {
          let intervalo = datasParaIntervaloBR(state.filtro.cadastro);
          items.push({descricao: 'Cadastro: ' + intervalo, chave: 'cadastro'});
        }

        state.filtroChips = items;
      },

      REMOVER_FILTRO(state, chip) {
        let isArray = Array.isArray(state.filtro[chip.chave]);

        if (isArray) {
          state.filtro[chip.chave] = [];
        } else {
          state.filtro[chip.chave] = '';
        }

        let index = state.filtroChips.findIndex(chip_ => chip_.chave == chip.chave);
        state.filtroChips.splice(index, 1);
      },

      SET_SEARCH(state, search) {
        state.search = search;
      },

      SET_TOTAL_DE_REGISTROS(state, total_de_registros) {
        state.total_de_registros = total_de_registros;
      },

      UPDATE_PAGINATION(state, options) {
        state.pagination = options;
      }

    },

    actions: {
      async listar({commit}, lista) {
        commit('LOADING_ON', null, {root: true});
        let cheques = await chequesApi.listar(lista);
        commit('SET_CHEQUES', cheques);
        commit('LOADING_OFF', null, {root: true});
      },

      async abrir({commit}, id) {
        commit('LOADING_ON', null, {root: true});
        let cheque = await chequesApi.abrir(id);
        commit('abrir', cheque);
        commit('LOADING_OFF', null, {root: true});
      },

      async salvar({commit}, cheque) {
        let novocheque = await chequesApi.salvar(cheque);
        commit('salvar', novocheque);
      },

      async atualizar({commit}, cheque) {
        await chequesApi.atualizar(cheque);
        commit('atualizar', cheque);
      },

      async emitente({commit}, cpfcnpj) {
        let emitente = await chequesApi.emitente(cpfcnpj);
        return emitente;
      },

      async atualizarStatusCheque({commit}, cheque) {
        await chequesApi.atualizarStatusCheque(cheque);
        commit('atualizarStatusCheque', cheque);
      },

      async excluir({commit}, id) {
        await chequesApi.excluir(id);
        commit('excluir', id);
      },

      async filtrarCheques({commit, state}, filtro) {
        commit('LOADING', true, {root: true});

        
        const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;
        
        const parametros = {
          ...filtro,
          page, 
          itemsPerPage,
          sortBy: sortBy[0], 
          sortDesc: sortDesc[0]
        }
        
        if (state.search > 0) {
          parametros.search = state.search;
          parametros.page = 1;
        }

        let { total, data } = await chequesApi.filtrarCheques(parametros);

        commit('SET_TOTAL_DE_REGISTROS', total);
        commit('SET_FILTRO', filtro);
        commit('PROCESSAR_FILTROCHIPS');
        commit('SET_CHEQUES', data);
        commit('LOADING', false, {root: true});
      },
    }
}
